if (!customElements.get('description-toggle')) {
  customElements.define(
    'description-toggle',
    class DescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.description = this.querySelector('.product__description');
        this.button = this.querySelector('.product__description-toggle');
        if (!this.description || !this.button) return;

        this.moreLabel = this.querySelector('[data-label-more]');
        this.lessLabel = this.querySelector('[data-label-less]');

        if (!this.bound) {
          this.expanded = false;
          this.button.addEventListener('click', () => this.setExpanded(!this.expanded));

          // Text clipped by overflow stays keyboard focusable, so expand rather
          // than letting focus land on a link the user cannot see.
          this.addEventListener('focusin', (event) => {
            if (!this.expanded && this.description.contains(event.target)) this.setExpanded(true);
          });

          // Line metrics change once the real font swaps in over the fallback.
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.sync());
          }

          this.bound = true;
        }

        // Catches late-loading images and reflow across the 750px breakpoint.
        this.resizeObserver = new ResizeObserver(() => this.scheduleSync());
        this.resizeObserver.observe(this.description);

        this.sync();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      scheduleSync() {
        if (this.pendingSync) return;
        this.pendingSync = true;
        requestAnimationFrame(() => {
          this.pendingSync = false;
          this.sync();
        });
      }

      // Clamp first, then keep the clamp only if it actually hid something.
      // Leaves the button alone while expanded, since it is the way back.
      sync() {
        if (this.expanded) return;
        this.description.classList.add('product__description--collapsed');
        const overflows = this.description.scrollHeight > this.description.clientHeight + 1;
        this.description.classList.toggle('product__description--collapsed', overflows);
        this.button.hidden = !overflows;
      }

      setExpanded(expanded) {
        this.expanded = expanded;
        this.description.classList.toggle('product__description--collapsed', !expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.moreLabel?.classList.toggle('hidden', expanded);
        this.lessLabel?.classList.toggle('hidden', !expanded);

        if (expanded) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      }
    }
  );
}
